import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { client } from 'utils/api-client';

export default function useDeleteStripeTerminalReader(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<{ error: string }>,
  string
> {
  const queryClient = useQueryClient();

  return useMutation((readerId: string) => client.delete(`stripe-terminal-readers/${readerId}/`), {
    onSuccess: () => {
      queryClient.invalidateQueries('gyms');
    },
  });
}
